import dynamic from 'next/dynamic'
import { SupportItem } from 'shared/common/Header/ui/SupportItem/Desktop'

import { IconButton } from 'shared/ui/iconButton'

import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './SupportModal.module.scss'

interface SupportModalProps {
  onClose: () => void
  isOpen: boolean
}

const supportItems = [
  {
    text: 'Просканируйте QR – Код или напишите нам на аккаунт',
    label: 'Telegram',
    link: 'https://t.me/marketmbank',
    logo: '/static/svg/telegram.svg',
    linkLabel: '@marketmbank',
    qr: '/static/png/telegramQr.png',
  },
  {
    text: 'Просканируйте QR – Код или напишите нам на номер',
    label: 'Whatsapp',
    link: 'https://wa.me/996224143333',
    logo: '/static/svg/whatsapp.svg',
    linkLabel: '+996 224 14 33 33',
    qr: '/static/png/whatsappQr.png',
  },
]
const Modal = dynamic(() => import('shared/ui/modal'), { ssr: false })

export function SupportModal({ isOpen, onClose }: SupportModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles.wrapper}>
        <div className={styles.supportHeader}>
          <h3 className={styles.title}>Cлужба поддержки</h3>
          <p className={styles.text}>
            Если у вас возникли вопросы, свяжитесь с нами любым удобным способом
          </p>
          <IconButton
            onClick={onClose}
            className={styles.closeButton}
            iconName="close"
            iconColor={globalStyles['--icon-primary']}
            buttonColor="extra"
            iconSize="medium"
          />
        </div>
        <div className={styles.contacts}>
          <span className={styles.contactLabel}>
            Номер телефона службы поддержки
          </span>
          <span className={styles.contactNumber}>+996 224 14 33 33</span>
          <span className={styles.contactTime}>
            Каждый день с 09:00 до 21:00
          </span>
        </div>
        {supportItems.map(item => (
          <SupportItem key={item.label} {...item} />
        ))}
      </div>
    </Modal>
  )
}
